<template>
  <app-page-container title="گزارشات">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field
          outlined
          rounded
          placeholder="جستجو..."
          append-icon="mdi-magnify"
          dense
          v-model="searchTitle"
          class="mt-3"
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main mx-0">
        <v-col cols="12" class="pa-0">
          <v-card elevation="0" class="card-width body-card">
            <v-card-text class="">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="3" v-for="(item, index) in filterdList" :key="index">
                      <v-card
                        elevation="0"
                        class="items-card-8"
                        :style="item.background"
                        height="115px"
                      >
                        <v-card-text class="pa-2">
                          <v-card
                            elevation="0"
                            class="items-card-inside-8 mr-4 ml-n4"
                            :style="item.background2"
                            height="95px"
                          >
                            <v-card elevation="3" class="items-card-inside-3 mr-4" height="95px">
                              <v-card-text>
                                <v-row>
                                  <v-icon color="#E7F3FF" class="mr-2">{{ item.icon2 }}</v-icon>
                                  <v-spacer></v-spacer>
                                </v-row>
                                <v-row class="mt-1">
                                  <v-spacer></v-spacer>
                                  <span class="inside-card-title" @click="goToReport(item.title)">
                                    {{ item.title }}
                                  </span>
                                  <v-spacer></v-spacer>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-card>
                          <v-icon class="mt-n10" color="white">{{ item.icon }}</v-icon>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <alert-component
        ref="snackRef"
        :snakTimeOut="snakTimeOut"
        :snackColor="snackColor"
        :snackText="snackText"
        :snakIcon="snakIcon"
      ></alert-component>
    </template>
  </app-page-container>
  <!-- <div>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img
                :src="tableTitleImage.val"
                contain
                max-height="14vh"
                max-width="27vh"
              >
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">گزارشات</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field
                outlined
                rounded
                placeholder="جستجو..."
                append-icon="mdi-magnify"
                dense
                v-model="searchTitle"
                class="mt-3 mr-n16"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-row>
                        <v-col
                          cols="3"
                          v-for="(item, index) in filterdList"
                          :key="index"
                        >
                          <v-card
                            elevation="0"
                            class="items-card-8"
                            :style="item.background"
                            height="20vh"
                          >
                            <v-card-text>
                              <v-card
                                elevation="0"
                                class="items-card-inside-8 mr-4 ml-n4"
                                :style="item.background2"
                                height="16vh"
                              >
                                <v-card
                                  elevation="3"
                                  class="items-card-inside-3 mr-4"
                                  height="16vh"
                                >
                                  <v-card-text>
                                    <v-row>
                                      <v-icon color="#E7F3FF" class="mr-2">{{
                                          item.icon2
                                      }}</v-icon>
                                      <v-spacer></v-spacer>
                                    </v-row>
                                    <v-row class="mt-2">
                                      <v-spacer></v-spacer>
                                      <span
                                        class="inside-card-title"
                                        @click="goToReport(item.title)"
                                        >{{ item.title }}</span
                                      >
                                      <v-spacer></v-spacer>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-card>
                              <v-icon class="mt-n10" color="white">{{
                                  item.icon
                              }}</v-icon>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
  </div> -->
</template>
<script>
  import AlertComponent from '@/components/AlertComponent.vue';
  import AppPageContainer from '@/components/app/PageContainer.vue';
  import snackBar from '@/Mixins/snackBar.js';
  import ShearedMixin from '@/Mixins/Shared.js';
  import ShearedHelper from '@/Helpers/Shared.js';
  import AmarReportsHelper from '@/Helpers/Amar/AmarReportsHelper.js';
  export default {
    name: 'AmarReports',
    title: 'گزارشات آمار',
    inject: ['load', 'tableImg', 'tableTitleImage'],
    components: {
      AlertComponent,
      AppPageContainer,
    },
    mixins: [ShearedMixin, snackBar, ShearedHelper, AmarReportsHelper],
    created() {
      this.$root.$refs.AmarReports = this;
    },
    mounted() {
      this.mounteLoding();
    },
    data() {
      return {};
    },
    methods: {
      mounte: function () {},
    },
    computed: {
      filterdList() {
        return this.amarReports.filter((u) => {
          return u.title.toLowerCase().includes(this.searchTitle.toLowerCase());
        });
      },
    },
  };
</script>
<style scoped>
  .confirm-cancel-btn {
    border: solid 1px var(--dark-color);
    padding-top: 13px;
    padding-bottom: 15px;
    color: var(--dark-color);
  }
  .body-card {
    height: 80vh;
    overflow-y: auto !important;
  }
  @media only screen and (max-width: 1280px) {
    .items-card-8 {
      width: 95%;
    }
  }
  @media only screen and (min-width: 1280px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 2vh !important;
    }
    .items-card-8 {
      width: 90%;
    }
  }
  @media only screen and (min-width: 1366px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 98.5% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1536px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 1vh !important;
    }
    .items-card-8 {
      width: 90%;
    }
  }
  .items-card-8 {
    border-radius: 12px !important;
  }
  .items-card-inside-8 {
    border-bottom-right-radius: 250px !important;
  }
  .items-card-inside-3 {
    border-bottom-right-radius: 250px !important;
    margin-left: -16vh !important;
    border-top-left-radius: 12px !important;
    border-bottom-left-radius: 12px !important;
  }
  .inside-card-title {
    font-weight: 500;
    font-size: 18px;
    color: #212121;
    margin-top: 8px;
    letter-spacing: normal;
    cursor: pointer;
  }
</style>
